// extracted by mini-css-extract-plugin
module.exports = {"title":"AvailableDocumentationModal_title__2_Wkb","select":"AvailableDocumentationModal_select__3QC_t"};